import { useAsync } from '@tiger/hooks';
import { Empty } from 'antd';
import React, { FC } from 'react';
import ErrorBox from 'components/ErrorBox';
import Modal from 'components/Modal';
import PhotoSwipe from 'components/PhotoSwipe';
import ScrollTop from 'components/ScrollTop';
import { Loading } from 'components/Toast';
import GetSingleImg from 'modules/Deposit/components/GetSingleImg';
import pdf from 'static/images/icons/pdf.png';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import Item from './Item';
import './style.scss';

const Record: FC<{ isIRA?: boolean }> = ({ isIRA }) => {
    const [{ loading, error, data }, getData] = useAsync(() =>
        http
            .get(API.TRADE.deposit.getRecord(), {
                params: {
                    page: 1,
                    page_size: 10,
                    customer_id: security.currentCustomerId,
                    account_id: security.currentAccountId
                }
            })
            .then(({ data }) => data?.items)
    );

    const checkVoncherPicture = async pictures => {
        const urls = pictures.split(',');

        Modal.open({
            title: __('汇款凭证'),
            component: (
                <PhotoSwipe>
                    {urls.map((url, index) => {
                        return /\.pdf$/i.test(url) ? (
                            <img src={pdf} alt="PDF" className="pdf-picture" key={index} />
                        ) : (
                            <GetSingleImg url={url} key={index} />
                        );
                    })}
                </PhotoSwipe>
            ),
            width: 420,
            className: 'check-voncher-picture',
            closable: true,
            maskClosable: false
        }).result.catch(() => {});
    };

    function render() {
        if (error) {
            return <ErrorBox error={error} onClick={getData} />;
        }

        if (loading) {
            return <Loading tip={__('请稍等...')} />;
        }

        if (!data?.length) {
            return <Empty description={__('暂无数据')} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
        }

        return data.map((record, index) => (
            <Item checkVoncherPicture={checkVoncherPicture} record={record} key={index} />
        ));
    }

    return (
        <div className="deposit-record-root">
            <ScrollTop />
            <h3 className="main-title">{isIRA ? __('Contribution Notifications') : __('入金通知记录')}</h3>
            {render()}
            <p className="note">{__('注：仅显示最近10条记录')}</p>
        </div>
    );
};

export default Record;
